/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { Box, Input, Typography } from "@mui/material";
import { v4 as uuidV4 } from "uuid";
import Footer from "./footer";
import Dropdown from "./dropdown";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import SoftButton from "components/SoftButton";
import SoftBox from "components/SoftBox";
const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
  fontSize: 13,
};

const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
};

const selectStyle = {
  fontSize: "0.875rem",
  color: "#495057",
  border: "0.0625rem solid #d2d6da",
  background: "#fff",
  padding: "0.5rem 0.75rem",
  width: "100%",
  borderRadius: "0.5rem",
  outline: "none",
  minWidth: 100,
};

const Td = ({ children, style, row, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </th>
  );
};

const taxAuthoritiesOption = [
  {
    value: "Cục thuế TP.HCM",
    label: "Cục thuế TP.HCM",
  },
  {
    value: "Cục thuế An giang",
    label: "Cục thuế An giang",
  },
  {
    value: "Cục thuế Cần thơ",
    label: "Cục thuế Cần thơ",
  },
  {
    value: "Cục thuế Hà nội",
    label: "Cục thuế Hà nội",
  },
];
const typePeriodOption = [
  {
    value: "Kê khai theo năm",
    label: "Kê khai theo năm  ",
  },
  {
    value: "Kê khai theo quý",
    label: "Kê khai theo quý",
  },
  {
    value: "Kê khai theo tháng",
    label: "Kê khai theo tháng",
  },
  {
    value: "Lần phát sinh",
    label: "Lần phát sinh",
  },
];
const noteOption = [
  {
    value: "Kiểm toán nhà nước",
    label: "Kiểm toán nhà nước",
  },
  {
    value: "Thanh tra tài chính",
    label: "Thanh tra tài chính",
  },
  {
    value: "Thanh tra chính phủ",
    label: "Thanh tra chính phủ",
  },
  {
    value: "Cơ quan có thẩm quyền khác (nếu có)",
    label: "Cơ quan có thẩm quyền khác (nếu có)",
  },
  {
    value: "Khác",
    label: "Khác",
  },
];

const budgetOption = [
  {
    value: "Thuế thu nhập từ tiền lương, tiền công",
    label: "Thuế thu nhập từ tiền lương, tiền công",
  },
  {
    value: "Thuế thu nhập từ hoạt động sản xuất, kinh doanh cá nhân",
    label: "Thuế thu nhập từ hoạt động sản xuất, kinh doanh cá nhân",
  },
  {
    value: "Thuế thu nhập từ vốn đầu tư vốn cá nhân",
    label: "Thuế thu nhập từ vốn đầu tư vốn cá nhân",
  },
  {
    value: "Thuế thu nhập từ chuyển nhượng vốn (không bao gồm chuyển nhượng và chứng khoáng)",
    label: "Thuế thu nhập từ chuyển nhượng vốn (không bao gồm chuyển nhượng và chứng khoáng)",
  },
  {
    value: "Thuế TN từ C.nhượng BĐS, nhận T.Kê, quà tặng là BĐS",
    label: "Thuế TN từ C.nhượng BĐS, nhận T.Kê, quà tặng là BĐS",
  },
];

const dataTable = [
  {
    onlyTitle: true,
    bold: true,
    id: {
      value: uuidV4(),
      bg: true,
    },
    budget: {
      type: "select",
      value: "",
      bg: false,
      option: budgetOption,
    },
    taxAuthoritiesProvince: {
      type: "select",
      value: null,
      bg: false,
      option: taxAuthoritiesOption,
    },
    taxAuthoritiesRefund: {
      type: "input",
      value: null,
      bg: false,
    },
    taxAuthoritiesDistrict: {
      type: "select",
      value: null,
      bg: false,
      option: taxAuthoritiesOption,
    },
    taxAuthoritiesAnother: {
      type: "input",
      value: null,
      bg: false,
    },
    arise: {
      type: "input",
      value: "",
      bg: false,
    },
    period: {
      type: "input",
      value: "",
      bg: false,
    },
    number: {
      type: "input",
      value: "",
      bg: false,
    },
    date: {
      type: "input",
      value: "",
      bg: false,
    },
    collect: {
      type: "checkbox",
      value: false,
      bg: false,
    },
    temporaryCollection: {
      type: "checkbox",
      value: false,
      bg: false,
    },
    amount: {
      type: "input",
      value: 0,
      bg: false,
    },
  },
];

export default function RefundRequestTable({ formData, setFieldValue }) {
  const [data, setData] = useState(dataTable);

  useEffect(() => {
    setFieldValue("valuesRefundRequestTable", data);
  }, [data]);

  const handleChange = (values) => {
    const { id, name, value } = values;
    setData((prev) =>
      prev.map((item) => {
        if (item.id.value === id) {
          return { ...item, [name]: { ...item[name], value } };
        }
        return item;
      })
    );
  };

  const addNewRow = () => {
    const newRow = {
      onlyTitle: true,
      bold: true,
      id: {
        value: uuidV4(),
        bg: true,
      },
      budget: {
        type: "select",
        value: "",
        bg: false,
        option: budgetOption,
      },
      taxAuthoritiesProvince: {
        type: "select",
        value: null,
        bg: false,
        option: taxAuthoritiesOption,
      },
      taxAuthoritiesRefund: {
        type: "input",
        value: null,
        bg: false,
      },
      taxAuthoritiesDistrict: {
        type: "select",
        value: null,
        bg: false,
        option: taxAuthoritiesOption,
      },
      taxAuthoritiesAnother: {
        type: "input",
        value: null,
        bg: false,
      },
      arise: {
        type: "input",
        value: "",
        bg: false,
      },
      period: {
        type: "input",
        value: "",
        bg: false,
      },
      number: {
        type: "input",
        value: "",
        bg: false,
      },
      date: {
        type: "input",
        value: "",
        bg: false,
      },
      collect: {
        type: "checkbox",
        value: false,
        bg: false,
      },
      temporaryCollection: {
        type: "checkbox",
        value: false,
        bg: false,
      },
      amount: {
        type: "input",
        value: 0,
        bg: false,
      },
    };
    setData((prev) => [...prev, newRow]);
  };

  const removeRow = () => {
    if (data.length !== 1) {
      data.pop();
      const newRow = data;
      setData([...newRow]);
    }
  };

  return (
    <Box display="flex" flexDirection="column" mt={5}>
      <Box display="flex" flexDirection={"column"} justifyContent="flex-start">
        {/* <Typography component="label" variant="caption" fontSize={14} fontWeight="bold" mb={0.5}>
          II - Nội dung đề nghị hoàn trả khoản thu ngân sách nhà nước (NSNN):
        </Typography> */}
        <Typography variant="subtitle1" fontSize={13} fontStyle="normal">
          2. Hình thức đề nghị hoàn trả
        </Typography>
        <Typography variant="subtitle1" fontSize={13} fontStyle="normal">
          a.Bù trừ cho khoản phải nộp NSNN:
        </Typography>
      </Box>
      <Box>
        <table style={tableStyle}>
          <thead>
            <tr>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                STT
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                Khoản phải nộp, NSNN (Loại thuế, khoản phạt)
              </Td>
              <Td colSpan={4} style={{ textAlign: "center" }}>
                Cơ quan thu
              </Td>
              <Td colSpan={2} style={{ textAlign: "center" }}>
                Thời gian phát sinh khoản phải nộp (Kỳ tính thuế)
              </Td>
              <Td colSpan={2} style={{ textAlign: "center" }}>
                Quyết định thu/ Tờ khai hải quan
              </Td>
              <Td colSpan={2} style={{ textAlign: "center" }}>
                Nộp vào tài khoản
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                Số tiền
              </Td>
            </tr>
            <tr>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                Cơ quan thuế cấp cục
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                Cơ quan thuế quyết định hoàn thuế
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                Cơ quan thuế cấp chi cục
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                Cơ quan khác
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                Lần phát sinh
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                Kỳ tính
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                Số
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                Ngày
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                Thu NSNN
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                Tạm thu
              </Td>
            </tr>
            <tr>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                (1)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                (2)
              </Td>
              <Td colSpan={2} style={{ textAlign: "center" }}>
                (3)
              </Td>
              <Td colSpan={1} style={{ textAlign: "center" }}>
                (4)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                (5)
              </Td>
              <Td colSpan={2} style={{ textAlign: "center" }}>
                (6)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                (7)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                (8)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                (9)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                (10)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                (11)
              </Td>
            </tr>
          </thead>
          <tbody>
            {data &&
              data.length > 0 &&
              data.map((row, index) => (
                <tr key={row.id.value}>
                  <Td
                    row={""}
                    style={{
                      textAlign: "center",
                      background: "transparent",
                    }}
                  >
                    {index + 1}
                  </Td>
                  <Td
                    row={row}
                    style={{
                      textAlign: "center",
                      background: !row.budget.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.budget?.type !== "select" ? (
                      row.budget.value
                    ) : (
                      <SelectTable
                        name="budget"
                        id={row.id.value}
                        option={row.budget.option ? row.budget.option : defaultOption}
                        onChange={handleChange}
                      />
                    )}
                  </Td>
                  <Td
                    row={row}
                    style={{
                      textAlign: "center",
                      background: !row.taxAuthoritiesProvince.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.taxAuthoritiesProvince?.type !== "select" ? (
                      row.taxAuthoritiesProvince.value
                    ) : (
                      <SelectTable
                        name="budget"
                        id={row.id.value}
                        option={
                          row.taxAuthoritiesProvince.option
                            ? row.taxAuthoritiesProvince.option
                            : defaultOption
                        }
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "center",
                      background: !row.taxAuthoritiesProvince.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.taxAuthoritiesProvince?.type !== "select" ? (
                      row.taxAuthoritiesProvince.value
                    ) : (
                      <SelectTable
                        name="budget"
                        id={row.id.value}
                        option={
                          row.taxAuthoritiesProvince.option
                            ? row.taxAuthoritiesProvince.option
                            : defaultOption
                        }
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "center",
                      background: "transparent",
                    }}
                  >
                    {row.taxAuthoritiesRefund?.type !== "input" ? (
                      row.taxAuthoritiesRefund.value
                    ) : (
                      <InputTable
                        type={"text"}
                        id={row.id.value}
                        name="taxAuthoritiesRefund"
                        value={row.taxAuthoritiesRefund.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "center",
                      background: "transparent",
                    }}
                  >
                    {row.taxAuthoritiesAnother?.type !== "input" ? (
                      row.taxAuthoritiesAnother.value
                    ) : (
                      <InputTable
                        type={"text"}
                        id={row.id.value}
                        name="taxAuthoritiesAnother"
                        value={row.taxAuthoritiesAnother.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "center",
                      background: "transparent",
                    }}
                  >
                    {row.arise?.type !== "input" ? (
                      row.arise.value
                    ) : (
                      <InputTable
                        type={"text"}
                        id={row.id.value}
                        name="arise"
                        value={row.arise.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "center",
                      background: "transparent",
                    }}
                  >
                    {row.period?.type !== "input" ? (
                      row.period.value
                    ) : (
                      <InputTable
                        type={"text"}
                        id={row.id.value}
                        name="period"
                        value={row.period.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "center",
                      background: "transparent",
                    }}
                  >
                    {row.number?.type !== "input" ? (
                      row.number.value
                    ) : (
                      <InputTable
                        type={"text"}
                        id={row.id.value}
                        name="number"
                        value={row.number.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "center",
                      background: "transparent",
                    }}
                  >
                    {row.date?.type !== "input" ? (
                      row.date.value
                    ) : (
                      <InputTable
                        type={"text"}
                        id={row.id.value}
                        name="date"
                        value={row.date.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "center",
                      background: "transparent",
                    }}
                  >
                    {row.collect?.type !== "checkbox" ? (
                      row.collect.value
                    ) : (
                      <InputTable
                        fields="checkbox"
                        type={"text"}
                        id={row.id.value}
                        name="collect"
                        value={row.collect.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>
                  <Td
                    row={row}
                    style={{
                      textAlign: "center",
                      background: "transparent",
                    }}
                  >
                    {row.temporaryCollection?.type !== "checkbox" ? (
                      row.temporaryCollection.value
                    ) : (
                      <InputTable
                        fields="checkbox"
                        type={"text"}
                        id={row.id.value}
                        name="temporaryCollection"
                        value={row.temporaryCollection.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>
                  <Td
                    row={row}
                    style={{
                      textAlign: "center",
                      background: "transparent",
                    }}
                  >
                    {row.amount?.type !== "input" ? (
                      row.amount.value
                    ) : (
                      <InputTable
                        type={"number"}
                        id={row.id.value}
                        name="amount"
                        value={row.amount.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>
                </tr>
              ))}

            <tr>
              <Td
                colspan="12"
                row={{ bold: true }}
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                }}
              >
                Tổng cộng:
              </Td>
              <Td
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              >
                0
              </Td>
            </tr>
          </tbody>
        </table>
        <SoftBox display="flex" justifyContent="flex-start" gap={3} mt={2}>
          <SoftButton variant="gradient" color="dark" onClick={addNewRow}>
            Thêm dòng
          </SoftButton>
          <SoftButton variant="gradient" color="light" onClick={removeRow}>
            Xóa dòng
          </SoftButton>
        </SoftBox>
        {/* <Footer formData={formData} /> */}
      </Box>
    </Box>
  );
}

function InputTable(props) {
  const { id, onChange, type, fields, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;
  function handleChange(event) {
    console.log(type);
    const { name, value } = event.target;
    const newValue = value;
    if (type == "number") {
      if (!regexNumber.test(newValue)) return;
      onChange({ id, value: newValue !== "" ? +newValue : "", name });
    } else if (type == "decimal") {
      if (!regexDecimal.test(newValue)) return;
      onChange({ id, value: newValue, name });
    } else {
      onChange({ id, value: newValue !== "" ? newValue : "", name });
    }
  }
  return (
    <input
      type={fields ? fields : "text"}
      style={{
        textAlign: type === "number" ? "right" : "left",
        fontSize: 16,
        color: "#344767",
        border: "none",
        background: "transparent",
        padding: "4px 4px 4px 4px",
        width: "100%",
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}

function SelectTable(props) {
  const { id, onSelect, type, option, name, style, ...rest } = props;
  const [newValue, setNewValue] = useState();
  useEffect(() => {
    if (typeof onSelect === "function") {
      onSelect({ id, value: newValue !== "" ? newValue : "", name, type, rowType });
    }
  }, [newValue]);
  return (
    <div style={style}>
      <Dropdown option={option} id={id} newValue={newValue} setNewValue={setNewValue} />
    </div>
  );
}
